import { DASHBOARD_LOCALE_EN } from '@app/pages/dashboard/i18n/en';
import { AUTH_LOCALE_EN } from '@features/auth/i18n/en';
import { CUSTOMER_MANAGEMENT_LOCALE_EN } from '@features/customer/i18n/en';
import { DASHBOARD_KPIS_MANAGEMENT_LOCALE_EN } from '@features/dashboard-kpis/i18n/en';
import { CATALOG_SYNC_MANAGEMENT_LOCALE_EN } from '@features/catalog-sync/i18n/en';
import { EXCHANGE_RATE_MANAGEMENT_LOCALE_EN } from '@features/exchange-rate/i18n/en';
import { GROUP_MANAGEMENT_LOCALE_EN } from '@features/group/i18n/en';
import { HOTEL_MANAGEMENT_LOCALE_EN } from '@features/hotel/i18n/en';
import { MARKUP_MANAGEMENT_LOCALE_EN } from '@features/markup/i18n/en';
import { ORDER_MANAGEMENT_LOCALE_EN } from '@features/order/i18n/en';
import { PENDING_COLLECTION_MANAGEMENT_LOCALE_EN } from '@features/pending-collection/i18n/en';
import { PROVIDER_MANAGEMENT_LOCALE_EN } from '@features/provider/i18n/en';
import { PROVIDER_CALLS_LOCALE_EN } from '@features/provider-calls/i18n/en';
import { USER_MANAGEMENT_LOCALE_EN } from '@features/user/i18n/en';
import { UI_PAGINATOR_LOCALE_EN } from '@shared/ui/ui-paginator/i18n/locale';
import { UI_FILE_UPLOADER_LOCALE_EN } from '../../../shared/ui/ui-file-uploader/i18n/locale';
import { ILangVocab } from '../interface';
import { I18N_PARTIALS_EN } from '../partials/en';

export const locale: ILangVocab = {
  lang: 'en',
  data: {
    // Roles por su valor crudo, como los devuelve la API: la cabecera y la ficha
    // del perfil los traducen sin tener que mapear nada por el camino.
    ROLE: {
      ROLE_ADMIN: 'Administrator',
      ROLE_CUSTOMER: 'Customer',
      ROLE_USER: 'User',
    },
    CORE: {
      ROLE: {
        CUSTOMER: 'Customer',
        ADMIN: 'Admin',
        USER: 'User',
      },
      GENDER: {
        MALE: 'Masculine',
        FEMALE: 'Feminine',
        INTERSEXUAL: 'Intersexual',
        OTHER: 'Other',
      },
      THEME_COLOR: {
        DEFAULT: 'Default',
        BLUE: 'Blue',
        ORANGE: 'Orange',
        RED: 'Red',
        VIOLET: 'Violet',
        SLATE: 'Slate',
        GREEN: 'Green',
        YELLOW: 'Yellow',
      },
      THEME_MODE: {
        SYSTEM: 'System',
        LIGHT: 'Light',
        DARK: 'Dark',
      },
      THEME_TEMPLATE: {
        SIDEBAR: 'Sidebar',
        TOPBAR: 'Topbar',
      },
      USER_MENU: {
        PROFILE: 'Profile',
        LANG: 'Language',
        LOGOUT: 'Sing out',
        THEME: {
          LABEL: 'Theme',
          COLOR: 'Color',
          MODE: 'Dark/Light',
          TEMPLATE: 'Layout',
        },
      },
      ERROR_PAGES: {
        NOT_FOUND: {
          TITLE: 'Page not found',
          MESSAGE:
            'The page you are looking for was not found. Check if the URL is correct or contact the administrators if you think this is an error.',
        },
        SERVER_ERROR: {
          TITLE: 'System error',
          MESSAGE: 'Something went wrong! Please try again later.',
        },
        LAYOUT: {
          LOGO_ALT: 'Logo',
          GO_HOME_BUTTON: 'Go to home page',
        },
      },
      USER_PROFILE: {
        HEADER: {
          LAST_LOGIN: 'Last sign-in',
          MEMBER_SINCE: 'Member since',
        },
        TABS: {
          PROFILE: 'Profile',
          SECURITY: 'Security',
        },
        FIELD: {
          NAME: 'Name',
          EMAIL: 'Email',
          EMAIL_VERIFIED: 'Verified',
          EMAIL_UNVERIFIED: 'Not verified',
          MOBILE: 'Phone',
          ROLES: 'Roles',
          ROLES_FROM_GROUP: 'Inherited from group',
          GROUPS: 'Groups',
          STATUS: 'Status',
          STATUS_ENABLED: 'Active',
          STATUS_DISABLED: 'Disabled',
          NO_PASSWORD: 'no own password (Google sign-in)',
          LAST_LOGIN: 'Last sign-in',
          CREATED_AT: 'Created',
          UPDATED_AT: 'Last updated',
          LOCALE: 'Language',
          DNI: 'ID document',
          NATIONALITY: 'Nationality',
          GENDER: 'Gender',
          BIRTHDATE: 'Date of birth',
        },
        BREADCRUMB: 'Profile',
        OVERVIEW: {
          TITLE: 'Details',
        },
        CHANGE_PASSWORD: {
          TITLE: 'Change password',
          CURRENT_PASSWORD_LABEL: 'Current password',
          NEW_PASSWORD_LABEL: 'New password',
          CURRENT_PASSWORD_MISMATCH: 'The current password does not match.',
          SUCCESS_TITLE: 'Your password has been changed',
          SUCCESS_MESSAGE:
            'Your password has been changed successfully. You will be redirected to the home page.',
        },
      },
    },
    NAV: {
      GROUP: {
        OPERATION: 'Operations',
        HOTELBEDS: 'Hotelbeds',
        SETTINGS: 'Settings',
      },
      DASHBOARD: 'Dashboard',
      CATALOG: 'Catalogue',
      ARIA: 'Back office menu',
      TAG: 'Back office',
      MENU: 'Menu',
      CLOSE: 'Close',
      SKIP: 'Skip to content',
      HOME_ARIA: 'IBSOA Travel, back office, dashboard',
      LOGOUT: 'Sign out',
      FOOTER: 'IBSOA Travel back office, internal use only',
      FOOTER_PROVIDER_CALLS: 'Hotelbeds call status',
      FOOTER_WEB: 'Open the public website',
    },
    TEXT: {
      MANAGEMENT: 'Management',
      ADMINISTRATION: 'Administration',
      SELECT: 'Select',
      PLEASE_WAIT: 'Please wait',
      LOADING: 'Loading…',
      ONLINE_MESSAGE: 'Your internet connection was restored.',
      OFFLINE_MESSAGE: 'You are not connected to the internet.',
      NO_DATA: 'Nothing here yet.',
      NO_ITEMS_FOUND: 'No items found',
    },
    ...I18N_PARTIALS_EN,
    ...UI_PAGINATOR_LOCALE_EN,
    ...UI_FILE_UPLOADER_LOCALE_EN,
    ...AUTH_LOCALE_EN,
    ...USER_MANAGEMENT_LOCALE_EN,
    ...CUSTOMER_MANAGEMENT_LOCALE_EN,
    ...GROUP_MANAGEMENT_LOCALE_EN,
    ...ORDER_MANAGEMENT_LOCALE_EN,
    ...PENDING_COLLECTION_MANAGEMENT_LOCALE_EN,
    ...HOTEL_MANAGEMENT_LOCALE_EN,
    ...MARKUP_MANAGEMENT_LOCALE_EN,
    ...PROVIDER_MANAGEMENT_LOCALE_EN,
    ...EXCHANGE_RATE_MANAGEMENT_LOCALE_EN,
    ...DASHBOARD_KPIS_MANAGEMENT_LOCALE_EN,
    ...DASHBOARD_LOCALE_EN,
    ...CATALOG_SYNC_MANAGEMENT_LOCALE_EN,
    ...PROVIDER_CALLS_LOCALE_EN,
  },
};
